import {
  useRestartScraper,
  useScraperAction,
  useUpdateScraperConfig,
} from '../../api/mutations';
import { Ic } from '../../components/Ic';
import { deriveScraperState } from '../../lib/scraperState';
import type { Scraper } from '../../api/types';

/** Run / Pause / Resume / Restart. In the prototype these only fired a toast;
 *  here each hits a real endpoint. */
export function ScraperActions({ scraper, size = 'sm' }: { scraper: Scraper; size?: 'sm' | '' }) {
  const action = useScraperAction();
  const config = useUpdateScraperConfig();
  const restart = useRestartScraper();
  const state = deriveScraperState(scraper);
  const busy = action.isPending || config.isPending || restart.isPending;
  const cls = `btn ${size}`.trim();

  const setEnabled = (enabled: boolean) =>
    config.mutate({
      name: scraper.name,
      enabled,
      // Always echo the current interval — the handler defaults it to 300,
      // so omitting it would silently reset the schedule.
      interval_seconds: scraper.interval_seconds,
    });

  if (state === 'paused') {
    return (
      <button className={`${cls} success`} disabled={busy} onClick={() => setEnabled(true)}>
        <Ic.play className="ico" /> Resume
      </button>
    );
  }

  if (state === 'down') {
    return (
      <>
        <button className={cls} disabled={busy} onClick={() => restart.mutate(scraper.name)}>
          <Ic.refresh className="ico" /> Restart
        </button>
        <button className={`${cls} ghost`} disabled={busy} onClick={() => setEnabled(false)}>
          <Ic.pause className="ico" /> Pause
        </button>
      </>
    );
  }

  return (
    <>
      <button
        className={cls}
        disabled={busy}
        onClick={() => action.mutate({ name: scraper.name, action: 'run-now' })}
      >
        <Ic.zap className="ico" /> Run now
      </button>
      <button className={`${cls} ghost`} disabled={busy} onClick={() => setEnabled(false)}>
        <Ic.pause className="ico" /> Pause
      </button>
    </>
  );
}
